// extracted by mini-css-extract-plugin
export default {"loadingContainer":"AuthRedirect__loadingContainer___A3oqC"};